export function extractErrorMessage(err, fallback = "Ha ocurrido un error") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (x && typeof x === "object" && x.msg ? x.msg : String(x)));
    return msgs.join(" · ") || fallback;
  }
  if (d && typeof d === "object" && d.msg) return d.msg;
  return fallback;
}

export function levelBadgeClass(level) {
  switch (level) {
    case "Crítico":
      return "chip chip-critico";
    case "En desarrollo":
      return "chip chip-desarrollo";
    case "Funcional":
      return "chip chip-funcional";
    case "Sólido":
      return "chip chip-solido";
    default:
      return "chip bg-slate-100 text-slate-500 border-slate-200";
  }
}

export function formatDate(iso) {
  try {
    const d = new Date(iso);
    const months = [
      "ene", "feb", "mar", "abr", "may", "jun",
      "jul", "ago", "sep", "oct", "nov", "dic",
    ];
    const pad = (n) => n.toString().padStart(2, "0");
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()} · ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch (_e) {
    return iso;
  }
}
